import _ from 'underscore';
import { mapState } from 'vuex';
import payment from './preview/index.vue'


export default {
	name: 'payments_list',
	props: {
		scroll : Number
	},

	components : {
		payment
	},

	data : function(){

		return {
			loading : false,
			searchvalue : '',
			count : 0,
			sort : 'date_desc',
			sorting : {

				date_asc : {
					text : 'date_asc',
					field : 'date',
					sort : 'asc'
				},
				date_desc : {
					text : 'date_desc',
					field : 'date',
					sort : 'desc'
				}
			},

		}

	},

	created() {
		

	},

	destroyed() {
	},

	watch: {
		tscrolly : function(){

			if (this.$refs['list']){

				if (this.$refs['list'].height() - 1000 < this.tscrolly + this.dheight){
					this.$refs['list'].next()
				}
				
			}
			
		}
	},
	computed: mapState({
		dheight: state => state.dheight,
		tscrolly : function(state){
			return this.scroll || state.tscrolly
		},
		auth : state => state.auth,
		userinfo : state => state.userinfo?.userinfo,

		payload : function(){

		
			return {
				searchStrFilter : this.searchvalue,
				sortFields : [{
					field : this.sorting[this.sort].field,
					order : this.sorting[this.sort].sort
				}]
			}
		},

		menu : function(){

			return []

		},

		api : function(){

			return 'payments.admin.list'
			
		}
	}),

	methods : {

		reload : function(){
			if(this.$refs['list']) this.$refs['list'].reload()
		},

		search : function(v){
			this.searchvalue = v
		},

		setcount : function(v){
			this.count = v
		},

		sortchange : function(v){
			this.sort = v
		},

		paymentChanged : function(){
			this.reload()
		}
	},
}